import React, { Component, useState } from "react";
import { Modal } from "react-responsive-modal";
import { Link } from "react-router-dom";
import { Images } from "../../theme";
import { useTranslation } from "react-i18next";

import "./styles.css";

export default (props) => {
  const { t } = useTranslation();

  const BoxCard = (props) => {
    return (
      <>
        <div className="container">
          <div className="row my-5 pt-5 column-reverse">
            <div className="col-md-6 col-lg-6 spacingRightStyle">
              <p className="cartHeading">{t("Rent_Save_Green")}</p>
              <div>
                <span className="lightDesc">{t("Rent_Save_Description")} </span>
              </div>
              <Link to="/Renting">
                {" "}
                <button class="btn-custom btn-light mt-4">
                  {t("Renting_Works")}
                </button>
              </Link>
            </div>
            <div className="col-md-6 col-lg-6 text-center">
              <img
                src={Images.home_image}
                alt="image"
                style={{ width: "80%" }}
              />
            </div>
          </div>
          <div className="row my-5 pt-5">
            <div className="col-md-6 col-lg-6 text-center">
              <img
                src={Images.sit_laptop}
                alt="image"
                style={{ width: "80%" }}
              />
            </div>
            <div className="col-md-6 col-lg-6 spacingLeftStyle">
              <p className="cartHeading">{t("Lend_Start_Earning")}</p>
              <div>
                <span className="lightDesc">
                  {t("Lend_Start_Earning_Description")}
                </span>
              </div>
              <button
                onClick={props.listAnItem}
                class="btn-custom btn-light mb-5 mt-4"
              >
                {t("List_Earn")}
              </button>
            </div>
          </div>
        </div>
      </>
    );
  };

  return (
    <div>
      <div className="container card-disp d-flex justify-content-around">
        <div className="text-center mt-5">
          <img
            className="mb-3"
            src={Images.rocket_icon}
            alt="image"
            style={{ height: 60, width: 60 }}
          />
          <p className="card_text mb-0 MontserratSemiBold">
            {t("Community_Based")}
          </p>
          <p className="card_des">
            {t("Take_Part_Community")}
            <br /> {t("Grow_Together")}
          </p>
        </div>
        <div className="text-center mt-5">
          <img
            className="mb-3"
            src={Images.database_icon}
            alt="image"
            style={{ height: 60, width: 60 }}
          />
          <p className="card_text mb-0 MontserratSemiBold">{t("Save_Money")}</p>
          <p className="card_des">
            {t("Buy_Less_Rent_Demand")}
            <br />
            {t("Fraction_Price")}
          </p>
        </div>

        <div className="text-center mt-5">
          <img
            className="mb-3"
            src={Images.leafe_icon}
            alt="image"
            style={{ height: 60, width: 60 }}
          />
          <p className="card_text mb-0 MontserratSemiBold">
            {t("Help_The_Planet")}
          </p>
          <p className="card_des">{t("Live_Greener")}</p>
        </div>
      </div>
      {BoxCard(props)}
    </div>
  );
};
